import { prepareHeaders } from "./";
import cincolabdataEndpoints from "./cincolabdata.endpoints";

import type { LocalizedField } from "./types";

export interface Answer {
  field_key: string;
  label: LocalizedField;
  value: string;
}

interface Entry {
  id: string;
  email: string;
  is_winner: boolean;
  created_at: string;
  answers: Answer[];
}

/**
 * Retrieves a user by email and instance.
 * @param email - The user's email.
 * @returns The user entry, or null if no user was found for that email.
 * @throws If there is an error with the server (as opposed to a "not found").
 */
export const getUserByEmail = async (
  email: string,
): Promise<Entry | null> => {
  const response = await fetch(
    cincolabdataEndpoints.public.entries(import.meta.env.VITE_FORM_INSTANCE_KEY, email),
    {
      method: "GET",
      headers: prepareHeaders(),
      mode: "cors",
      redirect: "follow",
    },
  );

  if (response.status === 200) {
    const data = await response.json();
    if (data.length === 0) {
      return null;
    }
    return data[0];
  } else {
    throw new Error("Sorry there was an error with the server.");
  }
};
